import { render, staticRenderFns } from "./ViewOrEditReseller.vue?vue&type=template&id=159a89a2"
import script from "./ViewOrEditReseller.vue?vue&type=script&lang=js"
export * from "./ViewOrEditReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports